import { http } from 'vue'
import _ from 'lodash'

export default {
  // load sku for Checkout Button from the API server
  loadSkuForCheckout (context, params = {}) {
    const withParam = params.with ? '?with=' + params.with : ''
    return http.get('skus/' + params.id + withParam)
  },
  // load skus from the API server
  loadSkus (context, params = {}) {
    const filtersParam = params.filters ? '&filters=' + _.join(params.filters, '_') : ''
    return http.get('skus' + '?parent=' + params.parent + '&id=' + params.id + filtersParam)
  },
  // load sku from the API server
  loadSku (context, params = {}) {
    const withParam = params.with ? '?with=' + params.with : ''
    return http.get('skus/' + params.id + withParam)
  },
  // create address at the API server
  postSku (context, params = {}) {
    return http.post('skus', params.data)
  },
  // edit address at the API server
  putSku (context, params = {}) {
    return http.put('skus/' + params.id, params.data)
  },
  // delete address at the API server
  deleteSku (context, params = {}) {
    return http.delete('skus/' + params.id)
  },
  // save skus at the store
  saveSkus (context, payload) {
    context.commit('SAVE_SKUS', payload)
  },

  // load shipping from the API server to all companies
  loadSkuTransports (context, params = {}) {
    return http.get('transports?sku_id=' + params.skuId + '&neighborhood_id=' + params.neighborhoodId)
  },
  // load shipping from the API server to the specific company
  loadSkuCompanyTransport (context, params = {}) {
    return http.get('transports?company_sku_id=' + params.companySkuId + '&neighborhood_id=' + params.neighborhoodId)
  },
  // load shipping from the API server to company checkout
  loadCheckoutTransport (context, params = {}) {
    const emailParam = params.email ? '&email=' + params.email : ''
    return http.get('transports/' + params.neighborhoodId + '?sku_id=' + params.skuId + emailParam)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/skus/actions.js